import 'chart.js/auto';
import { useEffect, useState } from "react";
import { Bar } from 'react-chartjs-2';
import "./BarChartWidget.scss";

interface IProps {
    data: any;
    config?: any;
    variables: { [key: string]: string };
}

const DEFAULT_COLORS = ["#98c3ff", "#ffdea5", "#ffd7d9", "#4b9f47"];

const BarChartWidget = (props: IProps) => {

    const customColors = props.variables?.barColor
        ? props.variables.barColor.split(",").map((c) => c.trim()).filter(Boolean)
        : null;
    const palette = customColors && customColors.length > 0 ? customColors : DEFAULT_COLORS;
    const getBarColors = (count: number) =>
        Array.from({ length: count }, (_, i) => palette[i % palette.length]);

    return (
        <>
            {Array.isArray(props.data) && (
                <>
                    <div className={`BarChartWidget ${props.variables?.isLarge === "1" ? "large" : ""}`}>
                        <Bar
                        // When altText is present, use a two-line label with name on the first line and altText on the second. Otherwise, use a single-line label with just the name.
                        data={{
                            labels: props.data.map(x => x.altText ? [x.name, x.altText] : [x.name]),
                            datasets: [{
                                data: (props.data || []).map((x) => x.value),
                                borderColor: "#5542F6",
                                backgroundColor: getBarColors((props.data || []).length),
                                borderRadius: 7,
                                barThickness: 12
                            }],
                        }}
                        options={{
                            layout: {
                                padding: {
                                    top: 40,
                                    right: 25
                                }
                            },
                            responsive: true,
                            maintainAspectRatio: false,
                            interaction: {
                                mode: 'index',
                                intersect: false,
                            },
                            hover: {
                                mode: 'nearest',
                                intersect: false
                            },
                            plugins: {
                                legend: {
                                    display: false,
                                    position: "bottom"
                                },
                                tooltip: {
                                    mode: "index",
                                    intersect: false,
                                    backgroundColor: '#3F4692',
                                    cornerRadius: 16,
                                    padding: 8,
                                    caretSize: 6,
                                    caretPadding: 6,
                                    displayColors: false
                                },
                            },
                            scales: {
                                y: {
                                    grid: {
                                        tickLength: 0,
                                        borderDash: [5, 5],
                                        color: "#EAECF1",
                                    },
                                    beginAtZero: true,
                                    ticks: {
                                        autoSkip: true,
                                        maxTicksLimit: 5,
                                        padding: 6,
                                        font: {
                                            size: 12,
                                        }
                                    }
                                },
                                x: {
                                    grid: {
                                        tickLength: 0,
                                        color: "#EAECF1",
                                    },
                                    beginAtZero: true,
                                    ticks: {
                                        padding: 6,
                                        font: {
                                            size: 12,
                                        }
                                    },
                                }
                            }
                        }}
                        />
                    </div>
                </>
            )}
        </>
    )
}

export default BarChartWidget;